var anchors = document.querySelectorAll('.criteres-labels a[href^="#"]')
for(var i = 0; i < anchors.length; i++){
  anchors[i].addEventListener('click', function (e) {
    e.preventDefault()

    document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
    })
  })
}
  